import router from '@/router'
import { AppSidebar, AppHeader } from '@/components'
import { allowOnlyWithCompletedJourney } from '@/router/routerGuards'
import useWhitelabel from '@/composables/useWhitelabel'

export default () => {
  router.addRoute({
    path: '/chat',
    name: 'chat',
    components: {
      default: () => import('./chat.vue'),
      sidebar: AppSidebar,
      header: AppHeader
    },
    meta: {
      documentTitle: 'Assistant',
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    },
    beforeEnter: (to, from, next) => {
      const { config } = useWhitelabel('portal')

      if (!config.value.enableAIAssistant) {
        return next({ name: 'dashboard' })
      }

      return allowOnlyWithCompletedJourney()(to, from, next)
    }
  })
}
